<script context="module">
  import { makeWebsiteRequest as makeRequest } from "../Common/tools";
  import { verifyBrandDetails } from "../MarketingSettings/Tabs/Settings.svelte";
  import { External as Ext } from '../external';

  export async function saveAutomation(automationData) {
    let brandDetails = await verifyBrandDetails();
    let result = await makeRequest({
      action: "setAutomation",
      method: "post",
      data: {
        data: JSON.stringify(automationData)
      }
    });

    if (result) {
      let automation = result.data.automation;
      if (result.data.error) {
        Ext.Tools.showError(M[result.data.error] || result.data.error, {
          width: 450
        });
      }
      return automation;
    }
    return null;
  }
</script>

<script>
  import { deepClone, ignore, makeWebsiteRequest } from "../Common/tools";
  import AnalyticsAndGoals from "./Components/AnalyticsAndGoals.svelte";
  import GoalsList from "./Popups/GoalsList.svelte";
  import Flow from "./Components/Flow.svelte";
  import {External, M} from "../external";
  import { getExtraAutomationGoals } from "./static";
  import {onMount} from "svelte";

  export let data;
  let startAutomation = data ? !data.draft : false;
  let tab = External.WebPlatform.getUrlParameterMap(window.location.href)["tab"] || (data && !data.draft ? "analytics" : "flow");

  let previous = function () {
    if (tab === "flow") {
      External.CPanel.goToUrl("/me/crm/marketing/automations", true);
    } else {
      changeTab("flow");
    }
  };

  let backToAll = function () {
    External.CPanel.goToUrl("/me/crm/marketing/automations", true);
  };

  let setGoal = function () {
    let component;
    External.Tools.showWindow({
      title: M.SET_AUTOMATION_GOALS,
      icon: External.Popup.ICON_EDIT,
      width: 500,
      customClass: "add-member-dialog",
      isModal: false,
      withDarkBackground: true,
      forceAtRight: External.showBuilderPopupsOnFullHeight,
      markup: '<div class="popup-widget-wrapper bind-component"></div>',
      action: {
        onShow: function (popup, context) {
          component = new GoalsList({
            target: context.find(".bind-component")[0],
            props: {
              data: data.flow && data.flow.goals ? data.flow.goals : [],
              extraGoals: getExtraAutomationGoals(data),
              onChange: function () {
                if (!data.flow) {
                  data.flow = {};
                }
                data.flow.goals = component.get();
                External.CPanel.setChanged(true);
              }
            }
          });
        },
        onHide: function () {
          if (component) {
            component.$destroy();
            component = null;
          }
        }
      }
    });
  };

  let setOnOrOff = () => {
    if (!startAutomation && !data.flow) {
      startAutomation = 0;
      External.Tools.showError(M.PLEASE_SET_TRIGGERS_AND_STEPS);
      return;
    }
    /* allowing no triggers for an automation
    else if (!startAutomation && (!data.flow.start || !data.flow.start.triggers || data.flow.start.triggers.length === 0)) {
      startAutomation = 0;
      External.Tools.showError(M.PLEASE_SET_TRIGGERS);
      return;
    }
    */ else if (!startAutomation && (!data.flow.steps || data.flow.steps.length === 0)) {
      startAutomation = 0;
      External.Tools.showError(M.PLEASE_SET_STEPS);
      return;
    } else {
      let message = startAutomation ? M.TURN_OFF_AUTOMATION : M.TURN_ON_AUTOMATION;

      External.Tools.prompt(M.TURN_ON_AUTOMATION, message, save, function () {
        startAutomation = !startAutomation;
      });
    }
  };

  let changeTab = function (t) {
    tab = t;
  };

  async function save(onDone) {
    onDone = onDone || ignore;
    data.draft = !startAutomation;
    let newData = deepClone(data);
    delete newData.modified;
    let savedAutomation = await saveAutomation(newData);
    data.draft = savedAutomation.draft;
    startAutomation = !data.draft;

    Tools.showAutohideMessage(5, M.AUTOMATION_SAVED);

    External.CPanel.setChanged(false);
    onDone();
  }

  const getAllSteps = (steps, ofType) => {
    let allSteps = [];
    if (ofType.length > 0) {
      allSteps.push(... (steps.filter(step => ofType.indexOf(step.type) > -1)));
    } else {
      allSteps.push(...steps);
    }

    steps.forEach(item => {
      if (item.subflowA && item.subflowA.length) {
        allSteps.push(... getAllSteps(item.subflowA, ofType));
      }

      if (item.subflowB && item.subflowB.length) {
        allSteps.push(... getAllSteps(item.subflowB, ofType));
      }
    });

    return allSteps;
  }

  onMount(() => {
    let defaultEmail = External.Website.emailMarketingSettings.defaultEmail;
    let defaultSender = External.Website.emailMarketingSettings.defaultSender;
    // set the default sender name / emails to email steps with no sender name/email.
    if (data && data.flow && data.flow.steps && defaultEmail) {
      let emailSteps = getAllSteps(data.flow.steps || [], ["SEND_EMAIL", "SEND_EMAIL_NOTIFICATION"]);
      emailSteps.filter(step => step.settings && step.settings.length).forEach(step => {
        let updateSenderName = false;
        step.settings.filter(setting => setting.key === "email" && !setting.value).forEach(setting => {
          setting.value = defaultEmail;
          updateSenderName = true;
        });
        if (updateSenderName) {
          step.settings.filter(setting => setting.key === "name").forEach(setting => {
            setting.value = defaultSender;
          })
        }
      });
    }
  });
</script>

{#if data}
  <link href="https://fonts.googleapis.com/css2?family=Caveat&amp;display=swap" rel="stylesheet" />
  <div class="full-size flex flex-col" style="font-family: 'Roboto';">
    <div class="email-builder-lane flex flex-row align-center flex-none" style="padding: 0 40px;">
      <div class="flex align-center flex-1">
        <a class="light-gray-button middle-button circle-effect mr-5" href="automations" rel="tab">← {M.BACK_TO_ALL_AUTOMATIONS}</a>
        <div class="onoffswitch onoffswitch-big">
          <input type="checkbox" class="onoffswitch-checkbox modify" id="draft" name="quickView" on:click={setOnOrOff} bind:checked={startAutomation} />
          <label class="onoffswitch-label" for="draft">
            <span class="onoffswitch-inner" />
            <span class="onoffswitch-switch" />
          </label>
        </div>
      </div>
      <div class="flex align-center flex-none">
        <ul class="upper-navigation upper-navigation-bottom campaign-navigation">
          <li><a class:active={tab === "flow"} on:click={() => changeTab("flow")}>{M.AUTOMATION_FLOW}</a></li>
          <li><a class:active={tab === "analytics"} on:click={() => changeTab("analytics")}>{M.ANALYTICS_GOALS}</a></li>
        </ul>
      </div>
      <div class="flex align-center flex-1 justify-flex-end">
        <a on:click={setGoal} class="middle-button blue mr-5"><span class="material-icons-outlined"> emoji_events </span>{M.SET_A_GOAL}</a>
        <a on:click={() => save()} class="middle-button light-gray-button circle-effect mr-5"><span class="material-icons-outlined"> save </span>{M.SAVE}</a>
      </div>
    </div>
    {#if tab === "flow"}
      <div class="flex-1 overflow account-settings col20" style="padding: 40px; box-sizing: border-box;">
        <Flow bind:data={data.flow} automation={data} draft={data.draft} automationSave={save} />
      </div>
    {:else if tab === "analytics"}
      <AnalyticsAndGoals bind:data setGoal={setGoal} automationSave={save} backToAll={backToAll} previous={previous} />
    {/if}
  </div>

  <style>
    .automation-notes {
      height: auto;
    }
  </style>
{:else}
  <div class="col20 f-left">
    <h3 class="ta-center mt-25">
      {M.AUTOMATION_NOT_FOUND}
    </h3>
  </div>
{/if}
